import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import JobCard from "./Components/JobCard";
import Navbar from "./Components/Navbar";
import { db } from "./firebase";
import InputBox from "./Components/InputBox"
import Button from "./Components/Button";

function Findjob() {
  const [jobPosts, setJobPosts] = useState([]);
  const [filterDes, setFilterDes] = useState("");
  const [filtered, setFiltered] = useState([]);
  const [filterExp, setFilterExp] = useState("");
  function getData() {
   db.ref(`jobPosts/`).orderByChild("endDate").on("value", (snapshot) => {
      if (snapshot.exists()) {
        var data = Object.values(snapshot.val());
        setJobPosts(data);
        setFiltered(data.reverse());
      } else {
        console.log("No data found");
      }
    });
  }

  useEffect(() => {
    getData();
  }, []);

  // function handleFilterDes(query){
  //   setFilterDes(query);
  //   applyFilter()
    
  // }
  // function handleFilterExp(query){
  //   setFilterExp(query);
  //   applyFilter()

  // }
  
  function applyFilter(){
    if (filterDes && filterExp == "") {
      setFiltered(jobPosts)
    }
    else {

      const temp = jobPosts.filter((dabba) => {
        let jobDes = dabba.jobTitle.toLowerCase();
        let jobExp = dabba.exp.toLowerCase();
        let fd = filterDes.toLowerCase()
        let ex = filterExp.toLowerCase()

        return jobDes.includes(fd) || jobExp==ex;
      })
      setFiltered(temp)

    }
  }
function clearFilter(){
  setFilterDes("");
  setFilterExp("");
  setFiltered(jobPosts);
}

  return (

    <div>
      <div className="flex flex-col w-full px-5 md:px-10 mt-20">
        <p className="text-4xl font-bold leading-relaxed align-center">
          What are you looking for?
        </p>
        <p className="text-2xl font-semibold leading-relaxed">
          Internships and Jobs for Freshers!
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-8 w-full justify-around mt-3">
        <div></div>
        <div className="md:col-span-2 my-8 p-4 h-max shadow-xl m-4 ring-2 ring-gray-600 rounded-md">
          <div className="">
            <InputBox
              type="text"
              name="address_number"
              placeholder="Job Designation"
              value={filterDes}
              onChange={setFilterDes}
            ></InputBox>
          </div>

          <div className="">
            <label className="block uppercase tracking-wide text-charcoal-darker text-xs font-bold">
              Experience Required
            </label>
            <select
              required
              className="w-full rounded-md shadow-lg p-4 border-0 focus:outline-none"
              value={filterExp}
              onChange={({ target: { value } }) => setFilterExp(value)}
            >
              {[["Internship", "Internship"], ["0-1yrs", "0-1yrs"], ["1-3yrs", "1-3yrs"], ["3-6yrs", "3-6yrs"], ["6+yrs", "6+yrs"]].map(([value, text]) => (
                <option className="w-full rounded-md shadow-lg p-4 border-0 focus:outline-none" value={value}>
                  {text}
                </option>
              ))}
            </select>
          </div>

          <button  className="w-full text-white mt-4 bg-orange-500 rounded-lg p-2 shadow-xl font-semibold text-lg" onClick={applyFilter}> Apply Filter</button>
          <button  className="w-full text-black mt-4 ring-2 ring-orange-500 rounded-lg p-2 shadow-xl font-semibold text-lg" onClick={clearFilter}> Clear Filter</button>



        </div>
        <div className="md:col-span-4 m-4">
          {filtered.length ? filtered.map((post) => <JobCard data={post} />) : jobPosts.length ? <p className="text-center font-semibold text-xl mt-6">No Data Found.</p> : <p className="text-center font-semibold text-xl mt-6">Loading...</p>}
        </div>
        <div></div>
      </div>
    </div>

  );
}

export default Findjob;
